import {
  ADD_DREAM,
  ADD_DREAM_FAILURE,
  ADD_DREAM_SUCCESS,
  EDIT_DREAM,
  EDIT_DREAM_FAILURE,
  EDIT_DREAM_SUCCESS,
} from '../Actiontype';

export const AddDream = data => ({
  payload: data,
  type: ADD_DREAM,
});
export const AddDreamSuccess = response => ({
  payload: response,
  type: ADD_DREAM_SUCCESS,
});
export const AddDreamFailure = response => {
  console.log(response, 'llll');
  return {
    payload: response,
    type: ADD_DREAM_FAILURE,
  };
};
export const EditDream = data => ({
  payload: data,
  type: EDIT_DREAM,
});
export const EditDreamSuccess = response => ({
  payload: response,
  type: EDIT_DREAM_SUCCESS,
});
export const EditDreamFailure = response => ({
  payload: response,
  type: EDIT_DREAM_FAILURE,
});
